import React, { useState } from 'react';
import { clsx } from 'clsx';

// icons
import EmailIcon from '@assets/icons/email.svg?react';
import LockIcon from '@assets/icons/pass.svg?react';
import OnEye from '@assets/icons/on.svg?react';
import OffEye from '@assets/icons/off.svg?react';

// styles
import css from './styles.module.css';

type InputProps = {
  error?: string;
  name: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: 'text' | 'number' | 'password' | 'email';
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  inputFieldClassName?: string;
};

const AuthInput = (props: InputProps) => {
  const {
    error,
    name,
    value,
    onChange,
    type = 'text',
    placeholder = '',
    disabled = false,
    required = false,
    className = '',
    inputFieldClassName,
  } = props;

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleVisibilityToggle = () => {
    setPasswordVisible((prev) => !prev);
    setShowPassword((prev) => !prev);
  };

  const hasErrorMessage = Boolean(error);

  const wrapperCn = clsx(css.authInput, {
    [css.withError]: hasErrorMessage,
  });
  const inputFieldCn = clsx(css.inputField, inputFieldClassName);

  return (
    <div className={className}>
      <div className={wrapperCn}>
        <div className={css.iconWrapper}>
          {type === 'email' && (
            <EmailIcon className={css.icon} width={18} height={18} />
          )}
          {type === 'password' && (
            <LockIcon className={css.icon} width={18} height={18} />
          )}
        </div>

        <input
          id={name}
          name={name}
          type={type === 'password' && showPassword ? 'text' : type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          className={inputFieldCn}
        />

        <div className={css.afterIconWrapper}>
          {type === 'password' && (
            <button
              className={css.resetButton}
              onClick={handleVisibilityToggle}
            >
              {passwordVisible ? (
                <OnEye width={18} height={18} />
              ) : (
                <OffEye width={18} height={18} />
              )}
            </button>
          )}
        </div>
      </div>
      {error && <label className={css.errorMessage}>{error}</label>}
    </div>
  );
};

export default AuthInput;
